/* The extras on one order line, as the kitchen and the pass need to read them.
 *
 * An order line is not just its dish: a guest who ticked three portions of
 * chips has paid for a plate the ticket must describe, and a comes-with side
 * still has to be plated. Both are snapshots taken at order time —
 * {name, qty, price} for add-ons, {name} for complimentary items.
 *
 * The QUANTITY leads ("3× Chips"), because that is the part that changes what
 * leaves the kitchen. Anything shapeless is skipped rather than printed as
 * "[object Object]" on a ticket somebody has to cook from.
 */
export const extrasLine = (list) => (list || [])
  .map((a) => {
    if (typeof a === 'string') return a;
    if (!a || typeof a !== 'object' || !a.name) return '';
    const q = Number(a.qty) || 1;
    return q > 1 ? `${q}× ${a.name}` : a.name;
  })
  .filter(Boolean)
  .join(', ');
